module.exports = __webpack_public_path__ + "img/pattern.bf8cfead.png";